var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterList = function SvgFilterList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 276 168"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#4A4A4A",
    fontFamily: "Averta-Bold, Averta",
    fontSize: 16,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16
  }, "Thema\u2019s")), /*#__PURE__*/React.createElement("g", {
    fill: "#E8E8E8",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 16,
    x: 28,
    y: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#E8E8E8",
    transform: "translate(0 76)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 16,
    x: 28,
    y: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#E8E8E8",
    transform: "translate(0 112)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 16,
    x: 28,
    y: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#E8E8E8",
    transform: "translate(0 148)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 16,
    x: 28,
    y: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    x: 258,
    y: 42,
    fill: "#E8E8E8",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    x: 258,
    y: 77,
    fill: "#E8E8E8",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    x: 258,
    y: 114,
    fill: "#E8E8E8",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    x: 258,
    y: 150,
    fill: "#E8E8E8",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 24,
    fill: "#E8E8E8",
    rx: 1
  }))));
};
export default SvgFilterList;